export default __webpack_public_path__ + "static/media/source-cv-management.1ed5c144.svg";